import * as React from "react";
import { Modal, Button, Form } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";
import { useDispatch } from "@teamprevent/admin-redux";

import { goToParent } from "@teamprevent/common/routing";

import { GenericCaseTypeApi } from "../GenericCaseTypeApi";

import "../styles/edit-generic-case-type.scss";
import { GenericCaseType } from "../models";

type Props = {
    genericCaseType: GenericCaseType;
    onSaved: (genericCaseType: GenericCaseType) => void;
}

export const EditGenericCaseType: React.FunctionComponent<Props> = ({ genericCaseType, onSaved }) => {
    const dispatch = useDispatch();
    const [submitted, setSubmitted] = React.useState(false);
    const [name, setName] = React.useState(genericCaseType.name);
    const [active, setActive] = React.useState(genericCaseType.active);
    const [availableToCustomer, setAvailableToCustomer] = React.useState(genericCaseType.availableToCustomer);
    const [saving, setSaving] = React.useState(false);

    React.useEffect(() => {
        setName(genericCaseType.name);
        setActive(genericCaseType.active);
        setAvailableToCustomer(genericCaseType.availableToCustomer);
    }, [genericCaseType]);

    const onClose = React.useCallback(() => dispatch(goToParent()), [dispatch]);

    const onSave = React.useCallback(async () => {
        setSubmitted(true);
        if (!name.trim()) {
            return;
        }
        setSaving(true);
        const updatedGenericCaseType = { id: genericCaseType.id, name, active, availableToCustomer };
        await GenericCaseTypeApi.update(updatedGenericCaseType);
        onSaved(updatedGenericCaseType);
        setSaving(false);
        onClose();
    }, [active, availableToCustomer, genericCaseType.id, name, onClose, onSaved]);

    return (
        <Modal open size="small" closeOnDimmerClick={false}>
            <Modal.Header>Edit Generic Case Type</Modal.Header>
            <Modal.Content>
                <Form>
                    <Input.Text required showErrors={submitted} label="Name" onChange={setName} value={name} />
                    <div className={"fields-divider"} />
                    <Input.Checkbox showErrors={submitted} label="Active" onChange={setActive} value={active} />
                    <Input.Checkbox showErrors={submitted} label="Available to Customer" onChange={setAvailableToCustomer} value={availableToCustomer} />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>Cancel</Button>
                <Button loading={saving} disabled={saving} content="Save" onClick={onSave} />
            </Modal.Actions>
        </Modal>
    );
};
